/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/label-has-for */
import React, { useState } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import clsx from "clsx";
import Modal from "@visiblethread/react-components/dist/components/Modal";
import Button, {
  buttonVariants,
} from "@visiblethread/react-components/dist/components/Button";
import Checkbox, {
  checkboxStates,
} from "@visiblethread/react-components/dist/components/Checkbox";
import { getImage } from "utils";
import { modalTypes } from "constants/types";
import { hideModal, showModal } from "slices/app/actions/modals";
import { getDocumentsWithTerms, getExtensions } from "layout/discovery/helpers";
import { selectDocuments } from "slices/discovery/selectors";

const ExportMultipleDocumentsModal = ({ selectedTerms }) => {
  const documents = useSelector(selectDocuments);
  const [selectedDocs, setSelectedDocs] = useState(
    documents.filter((doc) => !doc.ignored)
  );
  const [selectedRowIndex, setSelectedRowIndex] = useState(-1);
  const dispatch = useDispatch();

  const closeModal = () => {
    dispatch(hideModal(modalTypes.DISCOVERY_EXPORT_MULTIPLE_DOCS));
  };

  const handleSelect = (document, index) => {
    setSelectedRowIndex(index);

    if (selectedDocs.includes(document)) {
      setSelectedDocs(selectedDocs.filter((doc) => doc !== document));
    } else {
      setSelectedDocs([...selectedDocs, document]);
    }
  };

  const handleSelectAll = () => {
    if (selectedDocs.length === documents.length) {
      setSelectedDocs([]);
    } else {
      setSelectedDocs(documents);
    }
  };

  const handleSave = () => {
    closeModal();

    dispatch(
      showModal(modalTypes.SHRED_TO_EXCEL, {
        documentsWithTerms: getDocumentsWithTerms(
          selectedDocs,
          selectedTerms,
          false
        ),
        extensions: getExtensions(selectedDocs),
      })
    );
  };

  const handleCancel = () => {
    closeModal();
  };

  const getSelectAllCheckboxState = () => {
    if (selectedDocs.length === documents.length) return checkboxStates.checked;
    if (selectedDocs.length === 0) return checkboxStates.empty;
    return checkboxStates.indeterminate;
  };

  return (
    <Modal
      show
      centered
      backdrop="static"
      className="fade-in discovery_export_multiple_docs"
      onDismiss={handleCancel}
    >
      <Modal.Header closeButton>
        <b>Export Multiple Documents</b>
      </Modal.Header>
      <Modal.Body>
        <div className="discovery_export_multiple_docs__body">
          <span className="discovery_export_multiple_docs__body__description">
            Check the documents you wish to include in the Shred and click
            &lsquo;Next&lsquo; below.
          </span>
          <label
            htmlFor="select-all-checkbox"
            className="discovery_export_multiple_docs__body__select_all"
          >
            <span>Select All</span>
            <Checkbox
              state={getSelectAllCheckboxState()}
              id="select-all-checkbox"
              handleChange={handleSelectAll}
            />
          </label>
          <div className="discovery_export_multiple_docs__body__docs_list">
            {documents.map((document, index) => (
              <label
                htmlFor={`document-checkbox-${index}`}
                className={clsx(
                  "discovery_export_multiple_docs__body__docs_list__document",
                  { selected: index === selectedRowIndex }
                )}
              >
                <span className="discovery_export_multiple_docs__body__docs_list__document__name">
                  <img src={getImage(document.Name)} alt="doc-img" />
                  {document.Name}
                </span>
                <Checkbox
                  state={
                    selectedDocs.includes(document)
                      ? checkboxStates.checked
                      : checkboxStates.empty
                  }
                  id={`document-checkbox-${index}`}
                  handleChange={() => handleSelect(document, index)}
                />
              </label>
            ))}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          content="Next"
          variant={buttonVariants.primary}
          disabled={selectedDocs.length === 0}
          onClick={handleSave}
        />
        <Button
          content="Cancel"
          variant={buttonVariants.secondary}
          disabled={false}
          onClick={handleCancel}
        />
      </Modal.Footer>
    </Modal>
  );
};

export default ExportMultipleDocumentsModal;

ExportMultipleDocumentsModal.propTypes = {
  selectedTerms: PropTypes.arrayOf(PropTypes.string),
};
